import gql from 'graphql-tag';

export const SaveApplicationMutation = gql`
  mutation ($applicationInput: ApplicationInput!, $applicationId: String,$applicationNote: String) {
    saveApplication (application: $applicationInput, applicationId: $applicationId,applicationNote:$applicationNote) 
    {
      id
    }
  }
`;



export const UpdateContractorAcceptRejectProject = gql`
  mutation ($applicationInput: ApplicationInput!, $applicationId: String) {
    updateContractorAcceptRejectProject (application: $applicationInput, applicationId: $applicationId) 
    {
      id
    }
  }
`;
